import {
  GridApiPremium,
  GridPaginationModel,
  GridPremiumSlotsComponent,
  GridRowClassNameParams,
  gridRowNodeSelector,
} from '@mui/x-data-grid-premium';
import { cn } from 'cn';
import { MutableRefObject } from 'react';

import { Footer, NoResults, Pagination } from './components';

export const PAGINATION_PAGE_SIZE_DEFAULT = 50;

export const slots: Partial<GridPremiumSlotsComponent> = {
  footer: Footer,
  noResultsOverlay: () => <NoResults message="Keine Ergebnisse." />,
  pagination: () => <Pagination />,
};

export function getRowClassName(
  params: GridRowClassNameParams,
  isGroupedColumn: boolean,
  apiRef: MutableRefObject<GridApiPremium | null>,
  isClickable: boolean,
) {
  //TODO: add a typesafe solution to support other statuses
  const statusClass =
    (params.row as { status?: string }).status === 'error' ? 'error' : '';
  let rowClassName: string;

  if (!isGroupedColumn) {
    rowClassName = statusClass;
  } else {
    const node = gridRowNodeSelector(apiRef, params.id);
    const base = node.type === 'group' ? 'group' : 'child';

    rowClassName = statusClass ? `${base} ${statusClass}` : base;
  }

  return cn(rowClassName, isClickable && 'cursor-pointer');
}
export const paginationModel: GridPaginationModel = {
  page: 0,
  pageSize: PAGINATION_PAGE_SIZE_DEFAULT,
};
